export default __webpack_public_path__ + "static/media/BQ-SA.32fada67.svg";